import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { LOYALTY_STAY_UPGRADE_SEARCH_FILTER_VALUE } from 'loyalty/constants/loyaltySearchFilters'
import { triplePointCampaignId } from 'takeovers/societyTriplePointsTakeover/societyTriplePointsTakeover.constants'

function useLoyaltyFilterLabels() {
  const intl = useIntl()

  return useMemo(() => {
    const getLabel = (value: string): string => {
      if (value === LOYALTY_STAY_UPGRADE_SEARCH_FILTER_VALUE) {
        return intl.formatMessage({
          id: 'cAuUythHUuZT7-LgxYEi',
          defaultMessage: 'Free upgrade',
          description: 'Display label for Free Room Upgrade loyalty filter',
        })
      }
      if (value === triplePointCampaignId) {
        return intl.formatMessage({
          id: 'XlAov-CORoNnm-oD05k6',
          defaultMessage: 'Triple Points',
          description: 'Filter option label for Triple Points campaign offers in search result filter panels',
        })
      }
      return value
    }

    return { getLabel }
  }, [intl])
}

export default useLoyaltyFilterLabels
